import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import Rating from "./Rating";
import EmptyState from "./EmptyState";

/**
 * Reusable Ratings & Reviews section for any profile.
 * Fetches /api/reviews/profile/{profile_id} and renders count + average + list.
 */
export default function ReviewsSection({ profileId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!profileId) return;
    api.get(`/reviews/profile/${profileId}`).then(({ data }) => setData(data)).catch(() => setData({ reviews: [], count: 0, average: 0 }));
  }, [profileId]);

  if (!data) return null;
  const { reviews, count, average } = data;

  return (
    <section className="mt-8" data-testid="reviews-section">
      <h3 className="font-display text-xl font-semibold tracking-tight">Ratings & Reviews</h3>
      <div className="mt-3">
        {count > 0 ? (
          <Rating value={average} count={count} testId="reviews-summary" />
        ) : (
          <div className="text-sm text-slate-500">No reviews yet</div>
        )}
      </div>
      {count > 0 && (
        <div className="mt-4 grid grid-cols-1 gap-3">
          {reviews.map((r) => (
            <Card key={r.review_id} className="p-4 border-slate-200" data-testid={`review-${r.review_id}`}>
              <div className="flex items-center gap-3">
                {r.reviewer_picture_url && (
                  <img src={r.reviewer_picture_url} alt="" className="w-8 h-8 rounded-full object-cover" />
                )}
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-slate-900">{r.reviewer_name}</div>
                  <Rating value={r.rating} size={14} showValue={false} />
                </div>
                <div className="text-xs text-slate-500">{new Date(r.created_at).toLocaleDateString()}</div>
              </div>
              <p className="mt-3 text-sm text-slate-700 leading-relaxed">{r.written_review}</p>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
